export default __webpack_public_path__ + "static/media/main-photo-min.78ff8880.jpg";